import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/commerce/RecommendationSlotPreview.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/v2/recommendations/preview`;
	}
	preview(e) {
		return this.api.post(n.baseUrl, e);
	}
};
export { n as RecommendationSlotPreview };

//# sourceMappingURL=RecommendationSlotPreview.js.map